module.exports = __webpack_public_path__ + "static/img/title-banner1-type3.b263fbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/5/title-banner1-type3.png
// module id = L1Jv
// module chunks = 1